import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { title } from 'node:process';
import { EventService } from '../../services/event.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-tokenomics',
  templateUrl: './tokenomics.component.html',
  styleUrl: './tokenomics.component.scss'
})
export class TokenomicsComponent {
  isMobile: boolean = false;
  windowSize: number = 0;
  currentLanguage = '';

  onResize(event: any) {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
    }
  }
  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private translate: TranslateService,
    private eventService: EventService,
  ) {
    this.currentLanguage = this.translate.currentLang;
    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.currentLanguage = params.lang;
    });

  }

  tokenomicsList: Array<any> = [
    {
      title: "tokenomics.card_1_title",
      desc: "tokenomics.card_1_desc"
    },
    {
      title: "tokenomics.card_2_title",
      desc: "tokenomics.card_2_desc"
    },
    {
      title: "tokenomics.card_3_title",
      desc: "tokenomics.card_3_desc"
    },
    {
      title: "tokenomics.card_4_title",
      desc: "tokenomics.card_4_desc"
    },
    {
      title: "tokenomics.card_5_title",
      desc: "tokenomics.card_5_desc"
    },
  ]

  navigateToPage(section: string): void {
    this.eventService.redirectTosection(section);
  }

    ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
    }
  }
}
